module.exports = __webpack_public_path__ + "static/media/client.2a6c222b.jpg";